(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-template-1.backup-cwv-14sep2026"] && !Shopify.designMode) return;
  try {
    var initPhotoSwipeFromDOM = function(gallerySelector) {

  // parse slide data (url, title, size ...) from DOM elements
  // (children of gallerySelector)
  var parseThumbnailElements = function(el) {
    var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
      numNodes = thumbElements.length,
      items = [],
      figureEl,
      linkEl,
      size,
      item;

    for (var i = 0; i < numNodes; i++) {

      figureEl = thumbElements[i]; // <figure> element
      // include only element nodes
      if (figureEl.nodeType !== 1) {
        continue;
      }

      linkEl = figureEl.children[0]; // <a> element
      if(linkEl.getAttribute('data-size')){
        size =  linkEl.getAttribute('data-size').split('x') ;
      }else{
        size =  [] ;
      }



      // create slide object
      item = {
        src: linkEl.getAttribute('href'),
        w: parseInt(size[0], 10),
        h: parseInt(size[1], 10)
      };



      if (figureEl.children.length > 1) {
        // <figcaption> content
        item.title = figureEl.children[1].innerHTML;
      }

      if (linkEl.children.length > 0) {
        // thumbnail element, retrieving thumbnail url
        item.msrc = linkEl.children[0].getAttribute('src');
      }

      item.el = figureEl; // save link to element for getThumbBoundsFn
      items.push(item);
    }

    return items;
  };

  // find nearest parent element
  var closest = function closest(el, fn) {
    return el && (fn(el) ? el : closest(el.parentNode, fn));
  };

  // triggers when user clicks on thumbnail
  var onThumbnailsClick = function(e) {
    e = e || window.event;
    e.preventDefault ? e.preventDefault() : e.returnValue = false;

    var eTarget = e.target || e.srcElement;

    // find root element of slide
    var clickedListItem = closest(eTarget, function(el) {
      return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
    });

    if (!clickedListItem) {
      return;
    }

    // find index of clicked item by looping through all child nodes
    // alternatively, you may define index via data- attribute
    var clickedGallery = clickedListItem.parentNode,
      childNodes = clickedListItem.parentNode.childNodes,
      numChildNodes = childNodes.length,
      nodeIndex = 0,
      index;

    for (var i = 0; i < numChildNodes; i++) {
      if (childNodes[i].nodeType !== 1) {
        continue;
      }

      if (childNodes[i] === clickedListItem) {
        index = nodeIndex;
        break;
      }
      nodeIndex++;
    }



    if (index >= 0) {
      // open PhotoSwipe if valid index found
      openPhotoSwipe(index, clickedGallery);
    }
    return false;
  };

  // parse picture index and gallery index from URL (#&pid=1&gid=2)
  var photoswipeParseHash = function() {
    var hash = window.location.hash.substring(1),
      params = {};

    if (hash.length < 5) {
      return params;
    }

    var vars = hash.split('&');
    for (var i = 0; i < vars.length; i++) {
      if (!vars[i]) {
        continue;
      }
      var pair = vars[i].split('=');
      if (pair.length < 2) {
        continue;
      }
      params[pair[0]] = pair[1];
    }

    if (params.gid) {
      params.gid = parseInt(params.gid, 10);
    }

    return params;
  };

  var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
    var pswpElement = document.querySelectorAll('.pswp')[0],
      gallery,
      options,
      items;

    items = parseThumbnailElements(galleryElement);

    // define options (if needed)
    options = {
      maxSpreadZoom: 1,
      bgOpacity: 0.7,
      zoomEl: true,
      history: false,
      pinchToClose: false,
      closeOnScroll: false,

      // define gallery index (for URL)
      galleryUID: galleryElement.getAttribute('data-pswp-uid'),

    };

    // PhotoSwipe opened from URL
    if (fromURL) {
      if (options.galleryPIDs) {
        // parse real index when custom PIDs are used
        // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
        for (var j = 0; j < items.length; j++) {
          if (items[j].pid == index) {
            options.index = j;
            break;
          }
        }
      } else {
        // in URL indexes start from 1
        options.index = parseInt(index, 10) - 1;
      }
    } else {
      options.index = parseInt(index, 10);
    }

    // exit if index not found
    if (isNaN(options.index)) {
      return;
    }

    if (disableAnimation) {
      options.showAnimationDuration = 0;
    }

    // Pass data to PhotoSwipe and initialize it
    gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
  };

  // loop through all gallery elements and bind events
  var galleryElements = document.querySelectorAll(gallerySelector);

  for (var i = 0, l = galleryElements.length; i < l; i++) {
    galleryElements[i].setAttribute('data-pswp-uid', i + 1);
    galleryElements[i].onclick = onThumbnailsClick;
  }

  // Parse URL and open gallery if it contains #&pid=3&gid=1
  var hashData = photoswipeParseHash();
  if (hashData.pid && hashData.gid) {
    openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
  }
  };

  // execute above function
  initPhotoSwipeFromDOM('.my-gallery');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wa-audit-before-polish-17sep"] && !Shopify.designMode) return;
  try {
    (() => {
  if (!/\/pages\/track-order\/?$/.test(location.pathname)) return;
  const main = document.querySelector('#MainContent');
  if (!main) return;
  let sequence = 0;
  const labelInputs = () => {
    main.querySelectorAll('.track123-input-content').forEach(group => {
      const input = group.querySelector('input.track123-input');
      const label = group.querySelector('.track123-input-label');
      if (!input || !label || !label.textContent.trim()) return;
      if (!label.id) {
        let id;
        do { id = 'wa-tracking-label-' + (++sequence); } while (document.getElementById(id));
        label.id = id;
      }
      if (!input.getAttribute('aria-label') && !input.labels.length) input.setAttribute('aria-labelledby', label.id);
    });
  };
  labelInputs();
  new MutationObserver(labelInputs).observe(main, {childList:true, subtree:true, characterData:true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wa-audit-improvements"] && !Shopify.designMode) return;
  try {
    (() => {
  if (!/\/pages\/track-order\/?$/.test(location.pathname)) return;
  const main = document.querySelector('#MainContent');
  if (!main) return;
  let sequence = 0;
  const labelInputs = () => {
    main.querySelectorAll('.track123-input-content').forEach(group => {
      const input = group.querySelector('input.track123-input');
      const label = group.querySelector('.track123-input-label');
      if (!input || !label || !label.textContent.trim()) return;
      if (!label.id) {
        let id;
        do { id = 'wa-tracking-label-' + (++sequence); } while (document.getElementById(id));
        label.id = id;
      }
      if (!input.getAttribute('aria-label') && !input.labels.length) input.setAttribute('aria-labelledby', label.id);
    });
  };
  labelInputs();
  new MutationObserver(labelInputs).observe(main, {childList:true, subtree:true, characterData:true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wa-contact-signals"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__waContactSignalsV1 || window.Shopify?.designMode) return;
  window.__waContactSignalsV1 = true;
  const query = new URL(window.location.href).searchParams;
  const debug = query.has('gtm_debug');
  const testContact = debug && query.get('wa_contact_test') === '1';
  if (debug) console.info('[WA contact verification] listener ready');
  let privacyRequested = false;
  const preparePrivacy = () => {
    const shopify = window.Shopify;
    if (typeof shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function' || privacyRequested) return;
    if (typeof shopify?.loadFeatures !== 'function') return;
    privacyRequested = true;
    try {
      shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], (error) => {
        if (error) privacyRequested = false;
      });
    } catch {
      privacyRequested = false;
    }
  };
  preparePrivacy();
  document.addEventListener('DOMContentLoaded', preparePrivacy, {once: true});
  window.addEventListener('load', preparePrivacy, {once: true});
  function queueGoogleCommand() {
    window.dataLayer.push(arguments);
  }
  window.addEventListener('click', (event) => {
    if (debug) console.info('[WA contact verification] click received', JSON.stringify({trusted:event.isTrusted, element:event.target instanceof Element}));
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    const link = event.target.closest('a[href]');
    if (!link) return;
    let destination;
    try { destination = new URL(link.href, window.location.origin); } catch { return; }
    let contactMethod = '';
    const digits = destination.pathname.replace(/\D/g, '');
    if (destination.protocol === 'tel:' && ['971564353565', '0564353565'].includes(digits)) {
      contactMethod = 'phone';
    } else if (['wa.me', 'api.whatsapp.com', 'www.whatsapp.com'].includes(destination.hostname)) {
      const phone = (destination.hostname === 'wa.me' ? destination.pathname : destination.searchParams.get('phone') || '').replace(/\D/g, '');
      if (phone === '971564353565') contactMethod = 'whatsapp';
    }
    if (!contactMethod) return;
    if (testContact) event.preventDefault();
    preparePrivacy();
    const privacy = window.Shopify?.customerPrivacy;
    if (debug) console.info('[WA contact verification]', JSON.stringify({privacyReady: typeof privacy?.analyticsProcessingAllowed === 'function', analyticsAllowed: typeof privacy?.analyticsProcessingAllowed === 'function' ? privacy.analyticsProcessingAllowed() : null, gtagReady: typeof window.gtag === 'function', dataLayerReady: Array.isArray(window.dataLayer)}));
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || privacy.analyticsProcessingAllowed() !== true) return;
    const parameters = {send_to: 'G-6QPQB4HFRR', page_path: window.location.pathname};
    if (debug) parameters.debug_mode = true;
    if (testContact) parameters.wa_contact_test = true;
    const eventName = contactMethod === 'phone' ? 'phone_click' : 'whatsapp_click';
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, parameters);
    } else if (Array.isArray(window.dataLayer)) {
      queueGoogleCommand('event', eventName, parameters);
    }
  }, {capture: true});
  if (debug) console.info('[WA contact verification] listener attached', JSON.stringify({testContact}));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wa-content-polish"] && !Shopify.designMode) return;
  try {
    (() => {
  const prepareTables = () => {
    const main = document.querySelector('#MainContent');
    if (!main) return;
    main.querySelectorAll('.rte table:not(.wa-table--cards):not(.wa-content-table)').forEach(table => {
      if (table.closest('form,.cart,.cart-drawer,[role="dialog"]')) return;
      const width = Math.max(0, ...Array.from(table.rows, row => Array.from(row.cells).reduce((sum,cell) => sum + cell.colSpan,0)));
      table.classList.add('wa-content-table');
      if (width > 2) table.classList.add('wa-content-table--wide');
      let wrap = table.parentElement;
      if (!wrap.matches('.wa-content-table-wrap,.wa-readable-table,.wa-table-wrap')) {
        wrap = document.createElement('div');
        table.before(wrap);
        wrap.append(table);
      }
      wrap.classList.add('wa-content-table-wrap');
      wrap.tabIndex = 0;
      wrap.setAttribute('role','region');
      const ar = document.documentElement.lang.startsWith('ar');
      wrap.setAttribute('aria-label',table.caption?.textContent.trim() || (ar ? 'جدول معلومات المنتج' : 'Product information table'));
      const hint = document.createElement('small');
      hint.className = 'wa-content-table-hint';
      hint.textContent = ar ? 'اسحب الجدول أفقياً لعرض جميع الأعمدة.' : 'Swipe across the table to see all columns.';
      wrap.after(hint);
      const updateHint = () => { hint.hidden = wrap.scrollWidth <= wrap.clientWidth + 2; };
      updateHint();
      if ('ResizeObserver' in window) new ResizeObserver(updateHint).observe(wrap);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',prepareTables,{once:true});
  else prepareTables();
  document.addEventListener('shopify:section:load',prepareTables);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wa-footer-pro"] && !Shopify.designMode) return;
  try {
    (() => {
  const media = window.matchMedia('(max-width: 749px)');
  document.querySelectorAll('.wa-footer-modern .wa-footer-pro').forEach((footer) => {
    if (footer.dataset.disclosuresReady) return;
    footer.dataset.disclosuresReady = 'true';
    const apply = () => footer.querySelectorAll('details.wa-footer-pro__group').forEach((group) => { group.open = !media.matches; });
    apply();
    media.addEventListener('change', apply);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wa-product-overview"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var link = event.target.closest('.wa-product-overview a[href="#wa-product-details"]');
    if (!link) return;
    var details = document.getElementById('wa-product-details');
    if (!details) return;
    event.preventDefault();
    event.stopPropagation();
    details.tabIndex = -1;
    details.focus({preventScroll: true});
    details.scrollIntoView({block: 'start', behavior: 'auto'});
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wa-storefront-refinement"] && !Shopify.designMode) return;
  try {
    (() => {
  const boot = () => {
    const mobile = matchMedia('(max-width:749px)');
    const footers = document.querySelectorAll('details.wa-footer-pro__group');
    const sync = () => footers.forEach(group => { group.open = !mobile.matches; });
    sync(); mobile.addEventListener('change', sync);
    if (!/\/pages\/.*(?:authorized|dealer|comparison)/.test(location.pathname)) return;
    const content = document.querySelector('.wa-page-basic__inner,.wa-page__content');
    if (!content || content.textContent.trim().split(/\s+/).length < 600) return;
    content.querySelectorAll('h2').forEach(heading => {
      if (!heading.parentElement.matches('.wa-brand,.wa-page-basic__inner,.wa-page__content') || heading.closest('details') || /safety|warning|medical|تحذير|سلامة|طبي/.test(heading.textContent.toLowerCase())) return;
      const details = document.createElement('details'); details.className = 'wa-compact-guide';
      const summary = document.createElement('summary'); summary.textContent = heading.textContent;
      const answer = document.createElement('div'); answer.className = 'wa-long-section__body';
      heading.before(details); details.append(summary, answer);
      let next = heading.nextElementSibling;
      while (next && !/^(H[12]|SECTION)$/.test(next.tagName)) { const following = next.nextElementSibling; answer.append(next); next = following; }
      heading.remove();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
})();
  } catch(e) { console.error(e); }
})();

})();
